module.exports = __webpack_public_path__ + "static/img/PX.4ec94ba.png";


//////////////////
// WEBPACK FOOTER
// ./static/seriesPic/PX.png
// module id = 8vnE
// module chunks = 1